import * as fromDatatype from '../datatype-library/index';

export interface bl_hc_professional_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  specialty: fromDatatype.VarcharDatatypeInterface;
  license_number: fromDatatype.VarcharDatatypeInterface;
  date_of_license: fromDatatype.TimestampTzDatatypeInterface;
  expiration_date: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  nationality: fromDatatype.VarcharDatatypeInterface;
  address_json: fromDatatype.JsonDatatypeInterface;
  is_doctor: boolean;
  is_pathologist: boolean;
  is_pharmacist: boolean;
  doctor_code: fromDatatype.VarcharDatatypeInterface;
  pathologist_code: fromDatatype.VarcharDatatypeInterface;
  pharmacist_code: fromDatatype.VarcharDatatypeInterface;
  doctor_id: fromDatatype.VarcharDatatypeInterface;
  pathologist_id: fromDatatype.VarcharDatatypeInterface;
  pharmacist_id: fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_hc_professional_hdr_RowClass implements bl_hc_professional_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    specialty: fromDatatype.VarcharDatatypeInterface;
    license_number: fromDatatype.VarcharDatatypeInterface;
    date_of_license: fromDatatype.TimestampTzDatatypeInterface;
    expiration_date: fromDatatype.TimestampTzDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    dob: fromDatatype.TimestampTzDatatypeInterface;
    gender: fromDatatype.VarcharDatatypeInterface;
    nationality: fromDatatype.VarcharDatatypeInterface;
    address_json: fromDatatype.JsonDatatypeInterface;
    is_doctor: boolean;
    is_pathologist: boolean;
    is_pharmacist: boolean;
    doctor_code: fromDatatype.VarcharDatatypeInterface;
    pathologist_code: fromDatatype.VarcharDatatypeInterface;
    pharmacist_code: fromDatatype.VarcharDatatypeInterface;
    doctor_id: fromDatatype.VarcharDatatypeInterface;
    pathologist_id: fromDatatype.VarcharDatatypeInterface;
    pharmacist_id: fromDatatype.VarcharDatatypeInterface;
    ref_1: fromDatatype.VarcharDatatypeInterface;
    ref_2: fromDatatype.VarcharDatatypeInterface;
    ref_3: fromDatatype.VarcharDatatypeInterface;
    ref_4: fromDatatype.VarcharDatatypeInterface;
    ref_5: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}